import { z } from 'zod';
import { PlatformApi } from '@/lib/api/platform/platformSdk';

/**
 * Loose because the bag is shared: other clients write keys this app does not
 * model, and the platform preserves them on write.
 */
const preferencesSchema = z.looseObject({ language: z.string().optional() });

/**
 * Parsed rather than read off the SDK type: the published
 * `@monksflow/platform-api-sdk` predates the field, so its type denies a
 * property the payload carries.
 */
export function readStoredLanguage(user: unknown): string | null {
  const bag = (user as { preferences?: unknown } | null | undefined)?.preferences;
  const parsed = preferencesSchema.safeParse(bag);
  return parsed.success ? (parsed.data.language ?? null) : null;
}

/**
 * Writes the caller's own language; the platform takes the identity from the
 * session, so there is no id to pass and no way to address another user.
 *
 * Rejects on a language the platform refuses, which the caller has to undo.
 */
export async function updateStoredLanguage(language: string): Promise<string | null> {
  const { data } = await PlatformApi.platformApi.patch<unknown>('/auth/me/preferences', {
    language,
  });

  const parsed = preferencesSchema.safeParse(data);
  return parsed.success ? (parsed.data.language ?? null) : null;
}
